<svelte:options tag="edi-svg-right" />

<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M1.07299 0.192314L5.82637 5.15339C5.94239 5.27346 6 5.42909 6 5.58408C6 5.73906 5.94239 5.89482 5.82637 6.01476L1.07299 10.9758C0.835394 11.2249 0.441104 11.233 0.19292 10.9945C-0.0569509 10.7576 -0.0650766 10.3616 0.174262 10.1142L4.53565 5.56068L0.175007 1.05395C-0.0643237 0.807321 -0.056198 0.410642 0.193665 0.173622C0.441882 -0.0649561 0.836744 -0.0566487 1.07299 0.192314Z"
		fill="#263B54"
	/>
</svg>
